import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
  UntypedFormArray,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { IArticles } from 'src/app/@interfaces/article.interface';
import { ICustomer } from 'src/app/@interfaces/customer.interface';
import { QuotationsService } from 'src/app/@pages/quotations/quotations.service';
import { WarehouseService } from 'src/app/@pages/warehouse/warehouse.service';
import { IWarehouse } from 'src/app/@interfaces/warehouse.interface';
import Swal from 'sweetalert2';
import { IVentaQuery } from 'src/app/@interfaces/venta.interface';
import { NgxSpinnerService, NgxSpinnerModule } from 'ngx-spinner';
import { CustomerService } from 'src/app/@pages/customer/customer.service';
import { DialogComponent } from '../../dialog.component';
import { ISeller } from 'src/app/@interfaces/seller.interface';
import { SellersService } from 'src/app/@pages/sellers/sellers.service';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ModifySalesService } from './modify-sale.service';
import { IQuota } from 'src/app/@interfaces/quotation.interface';
import { environment } from 'src/environments/environment';
import { CookieAuthService } from 'src/app/@shared/storage-variables/cookie-auth.service';
import { AlertsService } from '../../../services/alerts/alerts.service';
import { ArticleValidationsService } from '../../../services/validations/article-validations.service';
import { UnitConversionService } from 'src/app/@shared/services/unit-conversion.service';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { InventoryArticleWarningComponent } from '@shared-components';

@Component({
  selector: 'app-modify',
  templateUrl: './modify.component.html',
  styleUrls: ['./modify.component.css'],
  imports: [
    MatDialogModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatOptionModule,
    MatSelectModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatButtonModule,
    NgxSpinnerModule,
    CurrencyPipe,
    DecimalPipe,
    TranslatePipe,
    InventoryArticleWarningComponent,
  ],
})
export class ModifyComponent implements OnInit, OnDestroy {
  @Input() id_factura: number = 0;
  sellerList: Array<ISeller> = [];
  totalQuot: number = 0;
  newArticle: UntypedFormControl = this.fb.control('', Validators.required);
  newCustomer: UntypedFormControl = this.fb.control('', Validators.required);
  registerForm: UntypedFormGroup = this.fb.group({
    itemRows: this.fb.array(
      [
        this.fb.group({
          ids: [],
          article: [, Validators.required],
          quantity: [, Validators.required],
          price: [, Validators.required],
          discount: [0, Validators.required],
          subtotal: [0],
          warehouse: ['', Validators.required],
        }),
      ],
      Validators.required,
    ),
    tax_incl: false,
    tax: [, Validators.required],
    date: [, Validators.required],
    dueDate: [, Validators.required],
    seller: ['', [Validators.required]],
    positive_balance: ['0', [Validators.required]],
    observations: [null],
  });
  get rowsArr() {
    return this.registerForm.get('itemRows') as UntypedFormArray;
  }
  ventaIds: number[] = [];
  ventaIdsDelete: number[] = [];
  quotationToModify = {} as IQuota;
  dateToday = new Date();
  Sales: Array<IVentaQuery> = [];
  ArticleList: Array<IArticles> = [];
  CustomersList: Array<ICustomer> = [];
  WarehouseList: Array<IWarehouse> = [];
  companyId = '';
  user = '';
  rol = '';
  userSeller = '';
  articlesObj: Array<IArticles> = [];
  unsubscribe$ = new Subject<void>();
  showDevelopWarning: boolean = false;

  constructor(
    private seller: SellersService,
    private spinnerService: NgxSpinnerService,
    public dialog: MatDialog,
    private fb: UntypedFormBuilder,
    public quotation: QuotationsService,
    public warehouseS: WarehouseService,
    private customers: CustomerService,
    private translate: TranslateService,
    private modifySalesService: ModifySalesService,
    private alertsService: AlertsService,
    private cookieAuthService: CookieAuthService,
    private articleValidationsService: ArticleValidationsService,
    private unitConversionService: UnitConversionService,
  ) {}

  async ngOnInit(): Promise<void> {
    this.spinner();
    this.getAuthValues();
    this.quotationToModify = await this.getQuotation();
    this.setQuotation(this.quotationToModify);
    this.WarehouseList = await this.getWarehouses();
    this.getInputValues();
    this.setValuesByEnviroment();
  }

  getAuthValues() {
    const company = this.cookieAuthService.getCompanyObject;
    this.companyId = company!.Id_company!.toString();
    this.user = this.cookieAuthService.getUserId!;
    this.rol = this.cookieAuthService.getRolId!;
    this.userSeller = this.cookieAuthService.getUserSellerId!;
  }

  setValuesByEnviroment() {
    if (!environment.production) {
      this.showDevelopWarning = true;
    }
  }

  setQuotation(quotation: IQuota) {
    const { cliente } = quotation;
    this.Sales = quotation.venta;
    const [parameter] = this.Sales;
    const { total } = parameter;
    this.totalQuot = total;
    this.editQuotation(quotation, this.Sales, cliente);
  }

  getQuotation() {
    return new Promise<IQuota>((resolve, reject) => {
      this.quotation
        .getQuotation(this.id_factura)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((result) => {
          resolve(result);
        });
    });
  }

  getWarehouses() {
    return new Promise<IWarehouse[]>((resolve, reject) => {
      this.warehouseS
        .listWarehouses()
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((result) => {
          resolve(result);
        });
    });
  }

  getInputValues() {
    if (this.rol === '1' || this.rol === '3') {
      this.newCustomer.valueChanges
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((value: any) => {
          if (!value.__typename) {
            this.customers
              .searchCustomer(value, null, null)
              .pipe(takeUntil(this.unsubscribe$))
              .subscribe((result: any) => {
                this.CustomersList = result.customers;
              });
          }
        });
    } else {
      this.newCustomer.valueChanges
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((value: any) => {
          if (!value.__typename) {
            this.customers
              .searchCustomerByUserSeller(
                value,
                parseInt(this.userSeller!),
                null,
                null,
              )
              .pipe(takeUntil(this.unsubscribe$))
              .subscribe((result: any) => {
                this.CustomersList = result.customers;
              });
          }
        });
    }
  }

  addNewRow() {
    if (this.registerForm.invalid) {
      return;
    }
    const newRow = this.fb.group({
      article: [, Validators.required],
      quantity: [, Validators.required],
      price: [, Validators.required],
      discount: [0, Validators.required],
      subtotal: [0, Validators.required],
      warehouse: ['', Validators.required],
      unit: [''],
      customFactor: [1],
      quantityInBaseUnit: [1],
      isFactorEditable: [false],
    });
    this.rowsArr.push(newRow);
    const index = this.rowsArr.length - 1;
    this.subscribeToRowChanges(index);
    this.calculation();
  }

  deleteRow(rowIndex: number, id_ventaD: number) {
    if (this.rowsArr.length > 1) {
      this.rowsArr.removeAt(rowIndex);
      this.ventaIdsDelete.push(parseInt(id_ventaD.toString()));
    } else if (this.rowsArr.length === 1) {
      this.alertsService.showWarningAlert('You should not remove the last row');
    }
    this.calculation();
  }

  editQuotation(quotation: IQuota, sales: IVentaQuery[], customer: ICustomer) {
    let taxBool: boolean;
    if (quotation.tax_incl === 'true') {
      taxBool = true;
    } else {
      taxBool = false;
    }
    this.registerForm.patchValue({
      tax: quotation.tax,
      date: quotation.createdAt,
      dueDate: quotation.dueDate,
      seller: quotation.seller!,
      tax_incl: taxBool,
      positive_balance: quotation.positive_balance,
      observations: quotation.observations,
    });
    this.newCustomer.setValue(customer);
    this.registerForm.setControl('itemRows', this.setVenta(sales));
    this.setSellers(quotation);
  }

  setSellers(quotation: IQuota) {
    this.seller
      .listSellers()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((result: any) => {
        const list = result.filter(
          (item: any) => item.nombre !== quotation.seller!.nombre,
        );
        this.sellerList = list;
      });
  }

  setVenta(saleSets: IVentaQuery[]): UntypedFormArray {
    const formArray = new UntypedFormArray([]);
    for (let index = 0; index < saleSets.length; index++) {
      const sale = saleSets[index];
      const article = sale.articulo[0];
      const saleUnit = sale.id_sale_unit || article.unit?.id_unit;
      const quantityInBase = sale.quantity_in_base_unit || sale.cantidad;

      formArray.push(
        this.fb.group({
          ids: sale.id_venta,
          article: article,
          quantity: sale.cantidad,
          discount: sale.descuento,
          price: sale.precio,
          subtotal: sale.subtotal,
          warehouse: sale.almacen![0],
          unit: [saleUnit || ''],
          customFactor: [quantityInBase / sale.cantidad || 1],
          quantityInBaseUnit: [quantityInBase],
          isFactorEditable: [false],
        }),
      );
    }

    // Subscribe to changes for all rows
    // todo: improve this with better lifecycle management without setTimeout in uplift
    setTimeout(() => {
      for (let i = 0; i < formArray.length; i++) {
        this.subscribeToRowChanges(i);
      }
    }, 0);

    return formArray;
  }

  validRegister() {
    if (this.registerForm.invalid === true) {
      this.alertsService.showErrorAlert(
        'Please, fill in all the required fields!',
      );
      this.spinnerService.hide();
      return false;
    } else if (this.rowsArr.length > 11) {
      this.alertsService.showErrorAlert(
        'The quotation cannot have more than 11 items, please delete',
        ' ' + (this.rowsArr.length - 11),
      );
      this.spinnerService.hide();
      return false;
    } else if (
      this.articleValidationsService.checkDuplicateArticles(this.rowsArr)
    ) {
      this.alertsService.showErrorAlert(
        'You cannot add the same item more than once on the same invoice',
      );
      this.spinnerService.hide();
      return false;
    } else {
      return true;
    }
  }

  validDeleteSales() {
    if (this.rowsArr.value.length === this.Sales.length) {
      for (let i = 0; i < this.ventaIdsDelete.length; i++) {
        this.ventaIdsDelete.pop();
      }
    }
  }

  update() {
    this.spinnerService.show();
    const formValidation = this.validRegister();
    if (formValidation) {
      this.calculation();
      const variables = this.modifySalesService.setQuotationData(
        this.registerForm,
        this.rowsArr,
        this.newCustomer,
      );
      this.validDeleteSales();
      this.quotation
        .updateQuotation(
          this.id_factura,
          variables!.tax,
          variables!.cliente.id_cliente,
          variables!.venta[0].id_venta,
          this.ventaIdsDelete,
          variables!.venta[0].codigo,
          variables!.venta[0].cantidad,
          variables!.venta[0].precio,
          variables!.venta[0].descuento,
          variables!.venta[0].subtotal,
          variables!.venta[0].total,
          variables!.venta[0].id_almacen,
          variables!.venta[0].id_sale_unit,
          variables!.venta[0].quantity_in_base_unit,
          variables!.createdAt,
          variables!.dueDate,
          variables!.seller!.id_seller,
          variables!.tax_incl!,
          parseInt(this.user!),
          this.registerForm.get('positive_balance')?.value,
          this.registerForm.get('observations')?.value,
        )
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe({
          next: (result) => {
            if (result) {
              this.spinnerService.hide();
              this.alertsService
                .showSuccessfullAlert('Quotation has beed updated successfully')
                .then(async (result) => {
                  this.quotationToModify = await this.getQuotation();
                  this.setQuotation(this.quotationToModify);
                });
            } else {
              this.spinnerService.hide();
              Swal.fire(
                'Error',
                this.translate.instant('Something was wrong'),
                'error',
              );
            }
          },
          error: (error) => {
            this.spinnerService.hide();
            const message =
              error?.graphQLErrors?.[0]?.message ||
              error?.message ||
              'Error al actualizar la cotización';
            this.alertsService.showErrorAlert(message);
          },
        });
    } else {
      return;
    }
  }

  calculation() {
    let priceCal;
    let quantityCal;
    let discountCal;
    let taxCal;
    let subsubtotal;

    for (let i = 0; i < this.rowsArr.length; i++) {
      if (this.registerForm.get('tax_incl')?.value === false) {
        if (this.rowsArr.value[i].article.tax[0].value === 0) {
          taxCal = this.registerForm.value.tax;
        } else {
          taxCal = this.rowsArr.value[i].article.tax[0].value;
        }
      } else {
        taxCal = 0;
      }
      priceCal = this.rowsArr.value[i].price;
      quantityCal = this.rowsArr.value[i].quantity;
      discountCal = this.rowsArr.value[i].discount;
      if (taxCal) {
        if (discountCal != 0) {
          subsubtotal = quantityCal * priceCal;
          discountCal = (discountCal / 100) * subsubtotal;
          subsubtotal = subsubtotal - discountCal;
          if (this.rowsArr.value[i].article.tax[0].value === 0) {
            taxCal = (taxCal / 100) * subsubtotal;
          } else {
            taxCal = taxCal * subsubtotal;
          }
          this.rowsArr.value[i].subtotal = subsubtotal + taxCal;
        } else {
          subsubtotal = quantityCal * priceCal;
          if (this.rowsArr.value[i].article.tax[0].value === 0) {
            taxCal = (taxCal / 100) * subsubtotal;
          } else {
            taxCal = taxCal * subsubtotal;
          }
          this.rowsArr.value[i].subtotal = priceCal * quantityCal + taxCal;
        }
      } else if (discountCal != 0) {
        discountCal = (discountCal / 100) * (priceCal * quantityCal);
        this.rowsArr.value[i].subtotal = priceCal * quantityCal - discountCal;
      } else {
        this.rowsArr.value[i].subtotal = priceCal * quantityCal;
      }
    }
    this.totalQuot = 0;
    for (let i = 0; i < this.rowsArr.length; i++) {
      this.totalQuot = this.totalQuot + this.rowsArr.value[i].subtotal;
    }
  }

  displayFnArticle(article: any) {
    return article && article
      ? article.descripcion +
          new String(` - (`) +
          article.tax[0].value +
          new String(`)`)
      : undefined;
  }

  displayFnCustomer(customer: any) {
    return customer && customer ? customer.nombre : undefined;
  }

  closeDialog() {
    this.dialog.closeAll();
  }

  spinner(): void {
    this.spinnerService.show();
    setTimeout(() => {
      this.spinnerService.hide();
    }, 3000);
  }

  openDialog(i: number) {
    let dialogRef = this.dialog.open(DialogComponent, {
      disableClose: true,
      data: {
        filtro: this.newArticle,
        currentWarehouse: this.rowsArr.at(i).get('warehouse')?.value.id_almacen,
      },
    });
    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((result) => {
        if (result === '') {
          return;
        }
        this.rowsArr.at(i).get('article')?.setValue(result);
        this.calculation();
      });
  }

  taxValid(tax: boolean) {
    return tax === true ? true : false;
  }

  compareWarehouse(item1: any, item2: any) {
    if (item1 === null || item2 === null) {
      return false;
    }
    return item1.id_almacen === item2.id_almacen;
  }

  setPositiveBalance(customer: ICustomer) {
    const positive_balance = customer.positive_balance;
    this.registerForm.get('positive_balance')?.setValue(positive_balance);
  }

  /**
   * Subscribe to quantity and unit changes for a specific row
   */
  private subscribeToRowChanges(index: number) {
    const row = this.rowsArr.at(index);
    if (!row) return;

    // Subscribe to quantity changes
    const quantityControl = row.get('quantity');
    if (quantityControl) {
      quantityControl.valueChanges
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(() => {
          this.onUnitOrQuantityChange(index, 'quantity');
        });
    }

    // Subscribe to unit changes
    const unitControl = row.get('unit');
    if (unitControl) {
      unitControl.valueChanges
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(() => {
          this.onUnitOrQuantityChange(index, 'unit');
        });
    }
  }

  async onUnitOrQuantityChange(
    index: number,
    changedField: 'unit' | 'quantity',
  ) {
    const row = this.rowsArr.at(index);
    const article: IArticles = row.get('article')?.value;
    const quantity = parseFloat(row.get('quantity')?.value) || 1;
    const selectedUnit = parseInt(row.get('unit')?.value);

    if (!article || !article.unit?.id_unit) {
      return;
    }

    const baseUnit = Number(article.unit.id_unit);
    let factorToUse = parseFloat(row.get('customFactor')?.value) || 1;
    let shouldUpdateFactor = false;
    let isEditable = false;

    // ONLY calculate new factor when unit changes
    if (changedField === 'unit') {
      shouldUpdateFactor = true;

      // CASE 1: Base unit
      if (selectedUnit === baseUnit) {
        factorToUse = 1;
        isEditable = false;
      }
      // CASE 2: Article packaging unit
      else if (
        article.id_packaging_unit &&
        selectedUnit === article.id_packaging_unit
      ) {
        factorToUse = article.packaging_unit_factor || 1;
        isEditable = false;
      }
      // CASE 3: Other unit - look for conversion in DB
      else {
        try {
          const factor = await this.unitConversionService
            .getConversionFactor(selectedUnit, baseUnit)
            .toPromise();

          if (factor !== null && factor !== undefined) {
            factorToUse = factor;
            isEditable = false;
          } else {
            factorToUse = 1;
            isEditable = true;
          }
        } catch (error) {
          console.warn('Error looking for conversion:', error);
          factorToUse = 1;
          isEditable = true;
        }
      }
    }

    // Calculate quantity in base unit
    const convertedQuantity = quantity * factorToUse;

    // Update form
    if (shouldUpdateFactor) {
      row.patchValue(
        {
          quantityInBaseUnit: convertedQuantity,
          customFactor: factorToUse,
          isFactorEditable: isEditable,
        },
        { emitEvent: false },
      );
    } else {
      row.patchValue(
        {
          quantityInBaseUnit: convertedQuantity,
        },
        { emitEvent: false },
      );
    }

    // Recalculate totals
    this.calculation();
  }

  /**
   * Obtains the available units for an article in sales
   */
  getAvailableUnitsForSale(article: IArticles): any[] {
    const units: any[] = [];

    // Add base unit
    if (article.unit) {
      units.push({
        id_unit: article.unit.id_unit,
        description: article.unit.description,
        id_second: article.unit.id_second,
        isBase: true,
      });
    }

    // Add packaging unit if it exists and is different from the base.
    // id_packaging_unit is an Int and unit.id_unit an ID (string), so both
    // sides must be coerced before comparing. article.id_unit is not exposed
    // by the Articulos type, hence the nested unit.
    if (
      article.packagingUnit &&
      Number(article.id_packaging_unit) !== Number(article.unit?.id_unit)
    ) {
      units.push({
        id_unit: article.packagingUnit.id_unit,
        description: article.packagingUnit.description,
        id_second: article.packagingUnit.id_second,
        isPackaging: true,
      });
    }

    return units;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
